import {SafeLocalStorage} from "../utilities/SafeLocalStorage"

const localStorageKey = "lang"

export class LocalStorageLocale {
    static getValue = (): string | undefined => {
        const localStorageValue = SafeLocalStorage.getItem(localStorageKey)

        return localStorageValue !== null ? localStorageValue : undefined
    }

    static setValue = (value: string): void => {
        SafeLocalStorage.setItem(localStorageKey, value)
    }
}
